import { HStack, VStack, IconButton, Stack, Text, Box } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Container } from "../../components/Container";
import { Icon } from "../../components/Icon";
import { useStores } from "../../hooks/useStores";
import { isMobile } from "react-device-detect";
import ReactGA from "react-ga";

export const ClientVideoCategories: React.FC = observer(() => {
  const { session } = useStores();
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    session.getVideoCategories();
  }, []);

  // useEffect(() => {
  //   ReactGA.pageview(`/client/video-categories`);
  // }, []);

  const videoCategories = useMemo(() => {
    return session.videoCategories
      .filter((videoCategory) => videoCategory.enabled)
      .sort((itemA: any, itemB: any) => itemA.order - itemB.order);
  }, [session.videoCategories]);

  return (
    <Stack margin={"2rem"} gridGap={"2rem"}>
      <HStack marginBottom={"2rem"}>
        <IconButton
          aria-label="Back"
          icon={<Icon iconName={"HiArrowLeft"} />}
          variant={"ghost"}
          onClick={() => history.push("/client/board")}
        />
        <Stack>
          <Text fontSize="3xl">
            {t("screens.client.customer.onlineTraning")}
          </Text>
          <Text fontSize="xl" fontWeight={300}>
            {t("screens.client.customer.selectVideoCategory")}
          </Text>
        </Stack>
      </HStack>

      <Stack justifyContent={"center"} gridGap={"1rem"} flexWrap={"wrap"}>
        {videoCategories.map((videoCategory) => (
          <Container
            key={videoCategory.externalId}
            cursor={"pointer"}
            w="100%"
            onClick={() =>
              history.push(
                `/client/video-categories/${videoCategory.externalId}`
              )
            }
          >
            {isMobile ? (
              <VStack>
                <Box alignSelf="normal">
                  <Text fontSize="xl">{videoCategory.title}</Text>
                </Box>
                <Text>{videoCategory.description}</Text>
              </VStack>
            ) : (
              <HStack>
                <Box w="250px" minW="250px">
                  <Text fontSize="2xl">{videoCategory.title}</Text>
                </Box>
                <Text>{videoCategory.description}</Text>
              </HStack>
            )}
          </Container>
        ))}
      </Stack>
    </Stack>
  );
});
